import TWEEN, { Tween } from "@tweenjs/tween.js";
import * as THREE from "three";

function ExplodeModel(scene, renderer, controls) {
  this._init_(scene, renderer, controls);
}
ExplodeModel.prototype = {
  constructor: ExplodeModel,
  _init_: function(scene, renderer, controls, camera) {
    this.camera = camera;
    this.scene = scene;
    this.renderer = renderer;
    this.controls = controls;
    this.clock = new THREE.Clock();
    this.scene.children.forEach((child) => {
      if (child.name === "外部加载的模型") {
        this.model = child;
      }
    });
    this.objInfos = {};
    this.meshConut = 0;
    this.meshBox3 = new THREE.Box3();
    if (this.model) {
      
      if (this.model.animations && this.model.animations.length > 0) {
        //初始化模型自带动画相关数据
        this.mixer = new THREE.AnimationMixer(this.model);
        this.clip = this.model.animations[0];
        this.action = this.mixer.clipAction(this.clip);
        this.action.setLoop(THREE.LoopOnce);
      } else {
        // 初始化每个 mesh 的爆炸相关数据
        // 先计算模型的包围盒与中心（世界坐标）以及一个基于模型大小的爆炸半径
        var modelBox = new THREE.Box3().setFromObject(this.model);
        var modelCenter = new THREE.Vector3();
        modelBox.getCenter(modelCenter);
        var modelSize = new THREE.Vector3();
        modelBox.getSize(modelSize);
        var explodeRadius = Math.max(modelSize.length() * 0.5, 1);

        this.model.traverse((child) => {
          if (child.isMesh) {
            this.meshConut += 1;
            // 保存原始本地位置（clone 避免引用问题）
            let originPosition = child.position.clone();
            child.userData.originPosition = {
              x: originPosition.x,
              y: originPosition.y,
              z: originPosition.z,
            };

            // 计算 mesh 的世界中心
            var meshBox = new THREE.Box3().setFromObject(child);
            var meshCenter = new THREE.Vector3();
            meshBox.getCenter(meshCenter);

            // 方向向量：从模型中心指向 mesh 中心（世界坐标）
            var dir = new THREE.Vector3().subVectors(meshCenter, modelCenter);
            if (dir.length() < 1e-4) {
              // 如果重合，使用随机方向避免叠在一起
              dir.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5);
            }
            dir.normalize();

            // 目标世界坐标：在 meshCenter 方向上推进 explodeRadius
            var worldExplodePos = meshCenter.clone().add(dir.multiplyScalar(explodeRadius));

            // 把世界坐标转换为模型本地坐标（使得直接赋给 child.position 有意义）
            var localExplodePos = this.model.worldToLocal(worldExplodePos.clone());
            child.userData.explodePosition = localExplodePos;
          }
        });
      }
    }
    this.inited = true;
  },
  explode: function() {
    if (!this.inited) {
      this.$message.info("请等待模型加载完再重试");
      return;
    }
    console.log(this.model);
    // 如果模型本身携带动画，则播放模型动画；否则执行每个 mesh 的爆炸动画
    if (this.mixer) {
      this._playModelAnimation(false);
      console.log("播放模型自带动画");
      return;
    }
    this.model.traverse((child) => {
      if (child.isMesh) {
        this.animateModel(
          child.userData.originPosition,
          child.userData.explodePosition,
          this.callBack,
          child,
        );
      }
    });
  },
  resetExplode: function() {
    if (!this.inited) {
      this.$message.info("请等待模型加载完再重试");
      return;
    }
    console.log(this.model);
    // 如果模型本身携带动画，则反向播放模型动画以回到初始状态；否则执行每个 mesh 的还原动画
    if (
      this.mixer
    ) {
      this._playModelAnimation(true);
      console.log("反向播放模型自带动画");
      return;
    }
    this.model.traverse((child) => {
      if (child.isMesh) {
        this.animateModel(
          child.userData.explodePosition,
          child.userData.originPosition,
          this.callBack,
          child,
        );
      }
    });
  },

  // 播放模型自带动画，reverse: 是否反向播放
  _playModelAnimation: function(reverse) {
    if (
      !this.model ||
      !this.model.animations ||
      this.model.animations.length === 0
    )
      return;
    if (!this.mixer) this.mixer = new THREE.AnimationMixer(this.model);
    // 移除之前的 finished 监听器
    try {
      if (this._onMixerFinished && this.mixer.removeEventListener)
        this.mixer.removeEventListener("finished", this._onMixerFinished);
    } catch (e) {
        console.log(e);
    }
    if(!this.action) return;
    this. action.reset();
    this. action.clampWhenFinished = true;
    if (reverse) {
      this. action.time = this.clip.duration;
      this.action.timeScale = -1;
    } else {
      this.action.timeScale = 1;
    }
    this.action.play();
    this.updateModolAnimation();
    var self = this;
    this._onMixerFinished = function() {
      self.callBack && self.callBack();
    };
    if (this.mixer.addEventListener)
      this.mixer.addEventListener("finished", this._onMixerFinished);
  },
  animateModel: function(oldP, newP, callBack, mesh) {
    var tween = new TWEEN.Tween({
      x1: oldP.x,
      y1: oldP.y,
      z1: oldP.z,
    });
    tween.to(
      {
        x1: newP.x,
        y1: newP.y,
        z1: newP.z,
      },
      1000,
    );
    tween.onUpdate((object) => {
      mesh.position.set(object.x1, object.y1, object.z1);
    });
    tween.onComplete(() => {
      callBack && callBack();
    });
    tween.easing(TWEEN.Easing.Cubic.InOut);
    tween.start();
    this.tweenanimate();
  },

  callBack: function() {
    console.log("动画完成回调");
  },
  updateModolAnimation:function(){
    if (!this.mixer) return;
    // schedule next frame
    requestAnimationFrame(this.updateModolAnimation.bind(this));
    // use local clock to get a sensible delta in seconds
    var delta = this.clock.getDelta();
    try { this.mixer.update(delta); } catch (e) { /* ignore */ }
    // only render if camera is available
    if (this.camera) this.renderer.render(this.scene, this.camera);
  },
  tweenanimate: function(time) {
  var id = requestAnimationFrame(this.tweenanimate.bind(this));
  var result=TWEEN.update(time);
  if (!result) cancelAnimationFrame(id);
  }
};

export { ExplodeModel };
